import { MiniSheet } from '../../MiniSheet/index.js'
import { IconButton } from '../../IconButton/index.js'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import {
  INSERT_ORDERED_LIST_COMMAND,
  INSERT_UNORDERED_LIST_COMMAND,
  REMOVE_LIST_COMMAND,
} from '@lexical/list'
import { useState } from 'react'

export const SelectList = ({ nodeType, disabled, size }) => {
  const [editor] = useLexicalComposerContext()
  const [menuOpen, setMenuOpen] = useState(false)

  return (
    <MiniSheet
      onOpen={() => setMenuOpen(true)}
      onClose={() => setMenuOpen(false)}
    >
      <MiniSheet.Trigger>
        <IconButton
          tooltip={menuOpen ? null : 'Create list'}
          size={size}
          icon={nodeType === 'bullet' ? 'list-bulleted' : 'list-numbered'}
          trailChevron="down"
          toggled={['bullet', 'number'].includes(nodeType)}
          disabled={disabled}
        />
      </MiniSheet.Trigger>
      <MiniSheet.Items>
        <MiniSheet.Item
          size="small"
          icon="list-bulleted"
          toggled={nodeType === 'bullet'}
          keyHint="Cmd+Alt+4"
          tooltip="Bulleted list"
          keyHintVisualOnly
          onClick={() => {
            editor.update(() => {
              editor.dispatchCommand(
                nodeType === 'bullet'
                  ? REMOVE_LIST_COMMAND
                  : INSERT_UNORDERED_LIST_COMMAND,
                undefined,
              )
            })
          }}
        />
        <MiniSheet.Item
          size="small"
          icon="list-numbered"
          keyHint="Cmd+Alt+5"
          keyHintVisualOnly
          tooltip="Number list"
          toggled={nodeType === 'number'}
          onClick={() => {
            editor.update(() => {
              editor.dispatchCommand(
                nodeType === 'number'
                  ? REMOVE_LIST_COMMAND
                  : INSERT_ORDERED_LIST_COMMAND,
                undefined,
              )
            })
          }}
        />
      </MiniSheet.Items>
    </MiniSheet>
  )
}
